<template>
  <div class="relative" v-if="hasAggregations">
    <!-- toggle "is-active" class on .js-btn-toggler -->
    <a class="button flex items-center justify-center px-10" href="#" :class="{ 'is-active': expanded }" @click.prevent="expand()">
      <span class="mr-2">Filters</span>
      <svg class="transition-all transform" width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.83301 1.64554L5.33951 6.13729C5.23294 6.2743 5.06908 6.35443 4.89551 6.35443C4.72193 6.35443 4.55808 6.2743 4.45151 6.13729L0.958008 1.64554"
          stroke="#1B83A2"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>

    <!-- toggle .hidden class -->
    <div class="absolute top-full z-50 min-w-80 lg:min-w-120 rounded-b-lg bg-white shadow" :class="dropClass" v-show="expanded">
      <div v-if="aggregations">
        <div class="pb-2 border-b border-gray-300" :key="aggregationKey" v-for="(aggregation, aggregationKey) in aggregations">
          <div class="px-4">
            <span class="block my-4 text-md" v-text="aggregation.title"></span>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-2" v-if="aggregation.buckets.length > 0">
            <label
              class="flex items-center px-2 py-2 mx-2 text-mdx cursor-pointer hover:bg-semanticInfoLight rounded"
              v-for="(bucket, ind) in aggregation.buckets"
              :key="ind"
            >
              <input class="hidden" type="checkbox" v-model="current[aggregationKey]" @change="filter()" :value="bucket.key" :name="`${name}[]`" />
              <div class="flex items-center">
                <span
                  class="checkbox flex items-center justify-center w-6 h-6 mr-2 border border-gray-500 rounded-md bg-white bg-no-repeat bg-center"
                ></span>
                <span class="flex-1 text-gray-500 leading-none" v-html="bucket.key"></span>
              </div>
            </label>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-between px-4 py-4">
        <a class="flex items-center hover:text-btnBg" href="#" @click.prevent="clear()">
          <img class="relative -left-1" :src="`${$settings.theme_url}/assets/images/icons/icn-blue-clear.svg`" width="32" height="32" alt="" />
          Clear All
        </a>

        <a class="button-primary button-small" href="#" @click.prevent="close()">
          Done
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import isEmpty from "lodash/isEmpty"
import pickBy from "lodash/pickBy"
import FacetsMixin from "./../../mixins/facets.js"
export default {
  mixins: [FacetsMixin],
  props: {
    title: {
      type: String,
      default: "Facet",
    },
    name: {
      type: String,
      default: "filters",
    },
    dropClass: {
      type: String,
      default: "left-0 lg:left-auto lg:right-0",
    },
    results: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.current = this.value
  },
  data: () => ({
    current: {},
  }),
  methods: {
    close() {
      this.expanded = false
    },
    clear() {
      this.$emit("clear")
      this.expanded = false
    },
    filter() {
      this.$emit("input", this.current)
    },
  },
  watch: {
    value: {
      handler() {
        this.current = this.value
      },
      deep: true,
    },
  },
  computed: {
    aggregations() {
      if (!this.results?.data?.aggregations) {
        return false
      }

      return pickBy(this.results.data.aggregations, (value) => value?.buckets && value.buckets.length > 0)
    },
    hasAggregations() {
      return !isEmpty(this.aggregations)
    },
  },
}
</script>
